import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

export interface ApexAccountStatusSummaryDTO {
  ApexAccountNumber: string;
}

interface FetchApexAccountStatusSummaryParams {
  clientId: string;
  id: string;
}

const fetchApexAccountStatusSummary = ({
  clientId,
  id,
}: FetchApexAccountStatusSummaryParams): Promise<ApexAccountStatusSummaryDTO> =>
  authFetch(
    urlWithParams('/Consumer/ManagedAccounts/ApexAccountStatusSummary', {
      clientId,
      id,
    }),
  );

export const useApexAccountStatusSummaryQuery = () => {
  const { clientId, managedAccountId: id } = useTransferMoneyContext();

  return useQuery(queryKeys.apexAccountStatusSummary(clientId, id), () =>
    fetchApexAccountStatusSummary({ clientId, id }),
  );
};
